module.exports = __webpack_public_path__ + "static/media/Buenos Aires.d3fdefcf.svg";